import {
  getSelectedVehiclesAPIData,
  VehicleListing,
} from '@cinch-nx/data-search'
import { useEffect, useState } from 'react'
import CarouselSection from './carousel-section/carousel-section'

export interface RecentlyViewedCarsCarousel {
  title?: string
  showBrowseAllCarsCard?: boolean
}

export function RecentlyViewedCarsCarousel({
  title,
  showBrowseAllCarsCard,
}: RecentlyViewedCarsCarousel) {
  const [vehicles, setVehicles] = useState<VehicleListing[]>()

  const RECENTLY_VIEWED_KEY = 'cinch-recently-viewed-cars'

  const getVehicleIdsFromStorage = (): string[] | null => {
    if (window.localStorage.getItem(RECENTLY_VIEWED_KEY) !== null) {
      return JSON.parse(window.localStorage.getItem(RECENTLY_VIEWED_KEY) ?? '')
    }
    return null
  }

  useEffect(() => {
    const fetchRecentlyViewedVehicleData = async (vehicleIds: string[]) => {
      const data = await getSelectedVehiclesAPIData(vehicleIds.join(','))
      setVehicles(data.vehicleListings)
    }
    const vehicleIds = getVehicleIdsFromStorage()
    if (vehicleIds) {
      fetchRecentlyViewedVehicleData(vehicleIds)
    }
  }, [])

  return (
    <CarouselSection
      title={title}
      vehicles={vehicles}
      showBrowseAllCarsCard={showBrowseAllCarsCard}
    />
  )
}

export default RecentlyViewedCarsCarousel
